import * as userRequest from "@/utils/userRequest";

export default async function getBoostAprService(
    token: string,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) {
    try {
        const res = await userRequest.get("/mission/user-item", {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log("🚀 ~ getBoostAprService ~ res:", res);
        if (res.success) {
            onSuccess && onSuccess(res.data);
            return res.data;
        }
    } catch (err) {
        console.error("🚀 ~ getBoostAprService ~ err:", err);
        handleError && handleError(err);
        throw err;
    }
}
